<template>
	<div>
		<div class="row mb-2">
			<div class="col-lg-6">
				<label for="">Fecha *</label>
                <v-date-picker :masks="{input:'DD-MM-YYYY'}" v-model="VehiculoKilometraje.Fecha" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
			<div class="col-lg-6">
				<label>Odómetro (KM) *</label>
				<vue-numeric
					class="form-control "
					separator=","
					placeholder="0"
					:precision="0"
					v-model="VehiculoKilometraje.Horometro"
				></vue-numeric>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-12">
				<label for="">Observaciones</label>
				<textarea class="form-control" v-model="VehiculoKilometraje.Observaciones" cols="10" rows="4"></textarea>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:"Kilometraje",
    props:["poBtnSave","pIdVehiculo","pListKilometraje"],
	data() {
        return {
            Modal:true,
            FormName:'Kilometraje',
            EmitSeccion:this.poBtnSave.EmitSeccion,
            VehiculoKilometraje:{
                IdVehiculoKilometraje:0,
                IdVehiculo:0,
				Fecha:'',
				Horometro:0,
                Observaciones:'',
            },
            errorvalidacion:[],
			ListKilometraje:[]
        }
    },
	methods: {
		Guardar(){
			// if (this.VehiculoKilometraje.HorometroInicio>this.VehiculoKilometraje.HorometroFin) {
			// 	this.$toast.warning('El odómetro del inicio no puede ser mayor al odómetro fin');
			// 	return false;
			// }
			// let CantidadItemsKilometraje=0;
			// CantidadItemsKilometraje=this.ListKilometraje.length;
			// if (this.VehiculoKilometraje.IdVehiculoKilometraje==0) {
			// 	if (CantidadItemsKilometraje>0 && parseInt(this.VehiculoKilometraje.Horometro)<=parseInt(this.ListKilometraje[CantidadItemsKilometraje-1].Horometro)) {
			// 		this.$toast.warning('El Kilometraje no Puede Ser Menor al Último Registrado');
			// 		return false;
			// 	}
			// }
			// else{
			// 	if (CantidadItemsKilometraje>1 && parseInt(this.VehiculoKilometraje.Horometro)<=parseInt(this.ListKilometraje[CantidadItemsKilometraje-2].Horometro)) {
			// 		this.$toast.warning('El Kilometraje no Puede Ser Menor al Último Registrado');
			// 		return false;
			// 	}
			// }
			let Fecha='';
			if (this.VehiculoKilometraje.Fecha!='' && this.VehiculoKilometraje.Fecha!=undefined) {
                let day=this.VehiculoKilometraje.Fecha.getDate();
                let month=this.VehiculoKilometraje.Fecha.getMonth()+1;
                let year=this.VehiculoKilometraje.Fecha.getFullYear();
                Fecha=year+'-'+month+'-'+day;   
            }
            let formData=new FormData();
            formData.set('IdVehiculoKilometraje',this.VehiculoKilometraje.IdVehiculoKilometraje);
            formData.set('IdVehiculo',this.VehiculoKilometraje.IdVehiculo);
			formData.set('Horometro',this.VehiculoKilometraje.Horometro);
            formData.set('Observaciones',this.VehiculoKilometraje.Observaciones);
			formData.set('Fecha',Fecha);
            this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
            this.$http.post('vehiculokilometraje/post',formData).then((res)=>{
                this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $("#Kilometraje").modal("hide");
				this.bus.$emit('List');
                this.bus.$emit('ListaPrincipal');
            }).catch((err)=>{
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            });
        },
		Limpiar(){
            this.VehiculoKilometraje={
                IdVehiculoKilometraje:0,
                IdVehiculo:0,
				Fecha:new Date(),
				Horometro:0,
                Observaciones:'',
            }
        },
		Recuperar(){
            this.$http.get('vehiculokilometraje/recovery',{
                params:{
                    IdVehiculoKilometraje:this.VehiculoKilometraje.IdVehiculoKilometraje
                }
            }).then((res)=>{
                const objres=res.data.data.vehiculokilometraje;
                this.VehiculoKilometraje.IdVehiculoKilometraje=objres.IdVehiculoKilometraje;
                this.VehiculoKilometraje.IdVehiculo=objres.IdVehiculo;
				this.VehiculoKilometraje.Horometro=objres.Horometro;
                this.VehiculoKilometraje.Observaciones=objres.Observaciones;
				let formatedDate2 = objres.Fecha.replace(/-/g, "\/");
                this.VehiculoKilometraje.Fecha=new Date(formatedDate2);
            })
        },
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdVehiculo)=>{
            this.poBtnSave.disableBtn=false;
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdVehiculo!==undefined) {
                this.VehiculoKilometraje.IdVehiculo=IdVehiculo;
            }
            if (Id > 0) {
				this.VehiculoKilometraje.IdVehiculoKilometraje = Id;
				this.Recuperar();
			}
        });
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        },
		validate(){
			if (this.pListKilometraje!=undefined) {
				this.ListKilometraje=this.pListKilometraje;
			}
		}
    }
}
</script>

<style>

</style>
